module.exports = __webpack_public_path__ + "img/body-bg.91b0878c.jpg";